import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    // HStack,
    InputRightElement,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link,
  } from '@chakra-ui/react';
  import { useState } from 'react';
  import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { getUser } from '../redux/users/user_actions';
import axios from 'axios';
import { BASE_URL } from '../constants/config';
  
  export default function Signuppage() {
    const nav = useNavigate()
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false);

    const handleSignUp = async()=>{

      let data = await axios.post(BASE_URL+"/user/register", {
          name, email, password
      })
      let {message, status} = data.data
      if(status === 1)
      {
        alert(message)
        nav("/login")
      }
      else
      {
        alert(message)
      }
    }
  
    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              Registrate
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
            para disfrutar de todas nuestras funciones interesantes ✌️
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="userName" isRequired>
                <FormLabel>Usuario</FormLabel>
                <Input type="text" value={name} onChange={(e)=>setName(e.target.value)}/>
              </FormControl>
              <FormControl id="email" isRequired>
                <FormLabel>Correo Electrónico</FormLabel>
                <Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>Contraseña</FormLabel>
                <InputGroup>
                  <Input type={showPassword ? 'text' : 'password'} value={password} onChange={(e)=>setPassword(e.target.value)}/>
                  <InputRightElement h={'full'}>
                    <Button
                      variant={'ghost'}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }>
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button
                  loadingText="Submitting"
                  size="lg"
                  // bg={'blue.400'}
                  bg={"#3077d5"}
                  color={'white'}
                  onClick = {handleSignUp}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Registrarse
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align={'center'}>
                  ¿ Ya tienes usuario ? <Link onClick={()=>{
                    nav("/login")
                  }} color={'blue.400'}>Inicia Sesión</Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    );
  }